<template>
  <div class="hello">
    <div class="info1">
      <div style="justify-content: space-between;margin: 20px;" class="flex">
        <div class="flex">
          <img class="logo" :src="data.logo">
          <div>
            <div class="name">{{data.school_name}}</div>
            <div>院校代码：{{data.code}}</div>
            <div class="type">
              <span v-if="data.is_211==1">211</span> <span v-if="data.is_985==1">985</span><span>{{data.type}}</span>
            </div>
            <div class="url" v-if="data.school_url&&data.school_url">学校官网：<span
                @click.stop="openUrl(data.school_url)">{{data.school_url}}</span></div>
          </div>
        </div>
        <div class="school_rank flex">
          <div v-if="data.rank_list[0]!=''">
            <div>{{data.rank_list[0]}}名</div>
            <div>软科综合排名</div>
          </div>
          <div v-if="data.rank_list[1]!=''">
            <div>{{data.rank_list[1]}}名</div>
            <div>校友会排名</div>
          </div>
          <div v-if="data.rank_list[2]!=''">
            <div>{{data.rank_list[2]}}名</div>
            <div>武书连排名</div>
          </div>
          <div v-if="data.rank_list[4]!=''">
            <div>{{data.rank_list[4]}}名</div>
            <div>金苹果排名</div>
          </div>
          <div v-if="data.rank_list[3]!=''">
            <div>{{data.rank_list[3]}}名</div>
            <div>
              <div>US世界排名</div>
            </div>
          </div>
        </div>
        <el-button type="danger" v-if="data.marked==false" icon="el-icon-star-off" @click="collect(0)">收藏</el-button>
        <el-button type="danger" v-else icon="el-icon-star-on" @click="collect(1)">已收藏</el-button>
      </div>

    </div>
    <div class="" style="align-items: flex-start;">
      <div class="left">
        <el-tabs class="tabs" v-model="activeName" type="card" @tab-click="handleClick" tabPosition="left">
          <el-tab-pane label="院校概况" name="first">
            <div class="title">
              院校简介
            </div>
            <div class="info2" v-if="data.school_detail!=null">
              {{data.school_detail}}
            </div>
            <div class="info2" v-else style="text-align: left;text-indent: 0px;">
              暂无数据
            </div>
            <div class="flex" style="align-items: flex-start;justify-content: space-between;">
              <!--  左侧 -->
              <div class="left">
                <div class="title">
                  院校信息
                </div>
                <div class="info3 flex">
                  <span>
                    <div class="biaoti">主管部门</div>
                    <div class="neirong">{{data.management}}</div>
                  </span>
                  <span>
                    <div class="biaoti">所在地</div>
                    <div class="neirong">{{data.city_name}}</div>
                  </span>
                  <span>
                    <div class="biaoti">星级排名</div>
                    <div class="neirong">{{data.rank}}星</div>
                  </span>
                  <span>
                    <div class="biaoti">办学层次</div>
                    <div class="neirong">{{data.renown}}</div>
                  </span>
                  <span>
                    <div class="biaoti">类别</div>
                    <div class="neirong">{{data.category_name}}</div>
                  </span>
                  <span>
                    <div class="biaoti">重点学科数量</div>
                    <div class="neirong">{{data.num_subject}}</div>
                  </span>
                  <span>
                    <div class="biaoti">硕士点数量</div>
                    <div class="neirong">{{data.num_master}}</div>
                  </span>
                  <span>
                    <div class="biaoti">博士点数量</div>
                    <div class="neirong">{{data.num_doctor}}星</div>
                  </span>
                  <span>
                    <div class="biaoti">院士人数</div>
                    <div class="neirong">{{data.num_academician}}</div>
                  </span>
                  <span>
                    <div class="biaoti">藏书数量</div>
                    <div class="neirong">{{data.num_library}}</div>
                  </span>
                  <span>
                    <div class="biaoti">重点实验室数量</div>
                    <div class="neirong">{{data.num_lab}}</div>
                  </span>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <!-- 招录信息------------------------------------------- -->
          <el-tab-pane label="开设专业" name="three">
            <div class="zhuanye">
              <div class="title">开设专业</div>
              <div class="table1 flex">
                <div class="tablename flex">
                  <p>院校优势专业</p>
                </div>
                <el-table class="" :data="major.best.list" style="width:700px;">
                  <el-table-column prop="rank" label="评估结果" width="180">
                  </el-table-column>
                  <el-table-column prop="major_name" label="专业名称">
                  </el-table-column>
                </el-table>
              </div>
              <div class="table2 flex">
                <div class="tablename flex">
                  <p>国家特色专业</p>
                </div>
                <div class="tablemain flex">
                  <span v-for="(item,index) in major.special.list">{{item.major_name}}</span>
                </div>
              </div>
              <!-- <div style="margin-top: 15px;width: 547px;margin-left: 11px;">
                  <el-input placeholder="请输入内容" v-model="keyword">
                     <el-button slot="append" icon="el-icon-search" @click="search()">搜索</el-button>
                  </el-input>
                </div> -->
              <el-table class="table2" :data="major.list" border style="width:716px">
                <el-table-column prop="name" label="类别" width="180">
                </el-table-column>
                <el-table-column label="专业名称">
                  <template slot-scope="scope">
                    <span v-for="(item,index) in scope.row.list">
                      {{item.major_name}}
                    </span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-tab-pane>
          <el-tab-pane label="院校分数" name="second">
            <div class="title">
              学校招录信息
            </div>
            <div class="filter">
              <el-select style="width: 150px;" v-model="value1" placeholder="请选择年份" @change="changeyear($event,1)">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>

              <el-select v-model="value2" style="margin-left: 20px;width: 150px;" placeholder="请选择科目"
                @change="changetype($event,1)">
                <el-option v-for="item in options1" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
              <el-select @change="changebatch($event,1)" v-model="value3" style="margin-left: 20px;width: 150px;"
                placeholder="请选择批次">
                <el-option v-for="item in options2" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <el-table :data="schoolInfo" style="width: 100%;margin-bottom: 67px;">
              <el-table-column prop="year" label="年份">
              </el-table-column>
              <el-table-column label="招生类型">
                <template slot-scope="scope">
                  <div>{{scope.row.batch_name}}</div>
                  <div>{{scope.row.enroll_type}}</div>
                  <div>{{scope.row.examinee_type}}</div>
                </template>
              </el-table-column>
              <el-table-column prop="province_line" label="省控线">
              </el-table-column>
              <el-table-column prop="score" label="最低录取分">
              </el-table-column>
              <el-table-column prop="rank" label="位次">
              </el-table-column>
            </el-table>
            <div class="schoolscore">
              <div class="title">
                学校预测分
              </div>
              <el-table :data="forecast" style="width: 100%;" :cell-style="cellStyle">
                <el-table-column prop="year" label="年份" width="180">
                </el-table-column>
                <el-table-column label="招生类型" width="180">
                  <template slot-scope="scope">
                    <div>{{scope.row.batch_name}}</div>
                    <div>{{scope.row.enroll_type}}</div>
                    <div>{{scope.row.examinee_type}}</div>
                  </template>
                </el-table-column>
                <el-table-column prop="score_danger" label="冲刺分">
                </el-table-column>
                <el-table-column prop="score_safe" label="稳妥分">
                </el-table-column>
                <el-table-column prop="score_guarantee" label="保底分">
                </el-table-column>
                <el-table-column prop="score_actual" label="实际分" style="color: orange;">
                  <template slot="header">
                    <span style="color:roange">实际分</span>
                  </template>

                </el-table-column>
              </el-table>
              <!-- <div class="vip_mask">
                <img src="../../assets/lock.png" alt="">
                <p @click="$store.commit('openVip', true);">请先开通VIP!</p>
              </div> -->
            </div>
          </el-tab-pane>
          <el-tab-pane label="专业分数">
            <div class="title">
              专业招录信息
            </div>
            <div class="filter">
              <el-select style="width: 150px;" v-model="value1" placeholder="请选择年份" @change="changeyear($event,2)">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>

              <el-select v-model="value2" style="margin-left: 20px;width: 150px;" placeholder="请选择科目"
                @change="changetype($event,2)">
                <el-option v-for="item in options1" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
              <el-select v-model="value3" style="margin-left: 20px;width: 150px;" placeholder="请选择批次"
                @change="changebatch($event,2)">
                <el-option v-for="item in options2" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <el-table :data="majorInfo" style="width: 100%;" :cell-style="cellStyle">
              <el-table-column prop="year" label="年份" width="100">
              </el-table-column>
              <el-table-column label="招生类型" width="180">
                <template slot-scope="scope">
                  <div>{{scope.row.batch_name}}</div>
                  <div>{{scope.row.enroll_type}}</div>
                  <div>{{scope.row.examinee_type}}</div>
                </template>
              </el-table-column>
              <el-table-column label="专业名称">
                <template slot-scope="scope">

                  <div>
                    <span v-if="scope.row.enroll_limit==true" style="color:#C10B17 ;">(该专业有限制条件)</span>
                    {{scope.row.major_name}}
                    <!-- <span style="color: orange;">{{item.enroll_limit==true?'有专业限制':''}}</span> -->
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="major_code" label="专业代码">
              </el-table-column>
              <el-table-column prop="enroll_num" label="招生人数">
              </el-table-column>
              <el-table-column prop="score" label="最低录取分">
              </el-table-column>
              <el-table-column prop="rank" label="位次">
              </el-table-column>
              <el-table-column label="详情" width="250">
                <template slot-scope="scope">
                  {{scope.row.major_detail}}
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="招生计划">
            <!-- 招生计划 -->
            <div class="title">
              招生计划
            </div>
            <div class="filter">
              <el-select style="width: 150px;" v-model="value4" placeholder="请选择科目" @change="planchanger($event)">
                <el-option v-for="item in planOptions.enroll_type" :key="item.value" :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
              <el-select v-model="value5" style="margin-left: 20px;width: 150px;" placeholder="请选择批次"
                @change="planchanger1($event)">
                <el-option v-for="item in planOptions.batch_name" :key="item.value" :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
            <el-table :data="plan" style="width: 100%;" :cell-style="cellStyle">
              <el-table-column prop="year" label="年份" width="80">
              </el-table-column>
              <el-table-column prop="major_name" label="专业名称" width="100">
              </el-table-column>
              <el-table-column prop="major_code" label="招生代码">
              </el-table-column>
              <el-table-column label="招生类型" width="120">
                <template slot-scope="scope">
                  <div>{{scope.row.batch_name}}</div>
                  <div>{{scope.row.enroll_type}}</div>
                  <div>{{scope.row.examinee_type}}</div>
                </template>
              </el-table-column>
              <el-table-column prop="num" label="招生人数">
              </el-table-column>
              <el-table-column prop="school_year" label="修业年限">
              </el-table-column>
              <el-table-column label="学费">
                <template slot-scope="scope">
                  {{scope.row.money_year}}/年
                </template>
              </el-table-column>
              <el-table-column label="详情" width="450">
                <template slot-scope="scope">
                  {{scope.row.major_detail}}
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="招生章程">
            <div class="title">招生简章</div>
            <div class="info5">
              <p v-for="(item,index) in data.news" @click="goDetail1(item)">{{item.title}}</p>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <!--  <div class="right">
        <ad :data="data"></ad>
      </div> -->
    </div>
  </div>
</template>

<script>
  import ad from '../../components/ad.vue'
  export default {
    components: {
      ad
    },
    data() {
      return {
        activeName: 'first',
        keyword: '',
        options: [],
        options1: [],
        options2: [],
        value: '',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
        data: [],
        schoolInfo: [],
        forecast: [],
        major: [],
        old: [],
        year: '',
        type: '',
        batch_name: '',
        plan: [],
        planOptions: [],
        enroll_type: '',
        plan_batch_name: '',
        majorInfo: [],
        isVip: false
      }
    },
    created() {
      if (localStorage.getItem('userInfo')) {
        JSON.parse(localStorage.getItem('userInfo')).bind_card > 0 ? this.isVip = true : this.isVip = false
      }
      if (this.$route.query.activeName) {
        this.activeName = this.$route.query.activeName
      }
      this.$http.schoolDetail({
        id: this.$route.query.id
      }).then(res => {
        this.data = res.data
      })
      this.$http.schoolLine({
        school_id: this.$route.query.id
      }).then(res => {
        this.schoolInfo = res.data
      })
      this.$http.schoolLine({
        school_id: this.$route.query.id,
        type: 2
      }).then(res => {
        this.majorInfo = res.data
      })
      this.$http.schoolLineOption({
        school_id: this.$route.query.id
      }).then(res => {
        this.options = res.data[0]
      })
      this.$http.schoolScoreForecast({
        school_id: this.$route.query.id
      }).then(res => {
        this.forecast = res.data.data
        this.forecast.forEach(item => {
          item.history = JSON.parse(item.history)
        })
      })
      this.$http.schoolMajors({
        school_id: this.$route.query.id
      }).then(res => {
        this.major = res.data
        this.old = res.data.list
        console.log(res.data)
      })
      this.$http.schoolEnrollPlan({
        school_id: this.$route.query.id
      }).then(res => {
        this.plan = res.data.list
      })
      this.getOptions()
    },
    methods: {
      goDetail1(item) {
        this.$router.push('/Guide?id=' + item.id)
      },
      planchanger(e) {
        this.enroll_type = e
        this.$http.schoolEnrollPlan({
          school_id: this.$route.query.id,
          enroll_type: this.enroll_type,
          batch_name: this.plan_batch_name
        }).then(res => {
          this.plan = res.data.list
        })
      },
      planchanger1(e) {
        this.plan_batch_name = e
        this.$http.schoolEnrollPlan({
          school_id: this.$route.query.id,
          enroll_type: this.enroll_type,
          batch_name: this.plan_batch_name
        }).then(res => {
          this.plan = res.data.list
        })
      },
      getOptions() {
        this.$http.getOptions({
          school_id: this.$route.query.id
        }).then(res => {
          this.planOptions = res.data
        })
      },
      changeyear(e, num) {
        this.year = e
        this.value1 = e
        let type = num
        this.$http.schoolLine({
          school_id: this.$route.query.id,
          type: type,
          year: e
        }).then(res => {
          if (type == 2) {
            this.majorInfo = res.data
          } else {
            this.schoolInfo = res.data
          }

        })
        this.$http.schoolLineOption({
          school_id: this.$route.query.id,
          type: type,
          year: e
        }).then(res => {
          this.options1 = res.data[0]
        })
      },
      changetype(e, num) {
        this.type = e
        this.value2 = e
        let type = num
        this.$http.schoolLine({
          school_id: this.$route.query.id,
          type: type,
          year: this.year,
          enroll_type: e
        }).then(res => {
          if (type == 2) {
            this.majorInfo = res.data
          } else {
            this.schoolInfo = res.data
          }
        })
        this.$http.schoolLineOption({
          school_id: this.$route.query.id,
          year: this.year,
          enroll_type: this.type,
        }).then(res => {
          this.options2 = res.data[0]
        })
      },
      changebatch(e, num) {
        this.batch_name = e
        this.value3 = e
        let type = num
        this.$http.schoolLine({
          school_id: this.$route.query.id,
          type: type,
          year: this.year,
          enroll_type: this.type,
          batch_name: e
        }).then(res => {
          if (type == 2) {
            this.majorInfo = res.data
          } else {
            this.schoolInfo = res.data
          }
        })
      },
      collect(type) {
        this.$http.schoolMark({
          school_id: this.$route.query.id,
          cancel: type
        }).then(res => {
          this.$message.success('操作成功')
          this.$http.schoolDetail({
            id: this.$route.query.id
          }).then(res => {
            this.data = res.data
          })
        })
      },
      openUrl(url) {
        window.open(url)
      },
      search() {
        this.major.list = []
        for (let i = 0; i < this.old.length; i++) {
          for (let o = 0; o < this.old[i].list.length; i++) {
            if (this.old[i].list[o].major_name.indexOf(this.keyword) > -1) {
              this.major.list = this.old[i]
              console.log(this.major.list)
            }
          }
        }
        console.log(this.major.list)
      },
      cellStyle({
        row,
        column,
        rowIndex,
        columnIndex
      }) {
        if (columnIndex === 6) { //指定坐标rowIndex ：行，columnIndex ：列
          return 'color:orange' //rgb(105,0,7)
        }

      }
    }
  }
</script>

<style scoped lang="scss">
  $color: #C10B17;

  .school_rank {
    justify-content: space-around;
    text-align: center;
    width: 600px;

    &>div {
      width: 100px;
      height: 100px;
      padding: 0 2px;

      &>div:nth-child(1) {
        margin: 17px 0;
        font-size: 22px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #C10B17;
      }

      &>div:nth-child(2) {
        text-align: center;
      }

      background: #FFFFFF;
      box-shadow: 0px 0px 15px 1px rgba(0, 0, 0, 0.07);
      border-radius: 14px;
    }
  }

  .filter {
    text-align: left;
    margin: 19px 0 21px 0;
  }

  .filter1 {
    width: 100%;
    text-align: left;
    margin-top: 30px;
  }

  .info6 {
    overflow: hidden;
    margin-top: 20px;

    .fenlei {
      font-weight: 400;
      color: $color;
      line-height: 30px;
      margin-top: 24px;
    }

    .info6-1 {
      margin: 15px 0 20px 23px;
    }

    img {
      width: 60px;
      height: 60px;
      border-radius: 50%;
      margin-right: 21px;
    }

    width: 420px;
    // height: 334px;
    background: #FFFFFF;
    box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.08);
    border-radius: 10px;
  }

  .info5 {
    background: #FFFFFF;
    // box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.08);
    border-radius: 10px;
    margin-bottom: 54px;
    overflow: hidden;

    p {
      text-align: left;
      margin: 21px 0 21px 0px;
    }
  }

  .table2 {
    width: 716px;
    background: #FFFFFF;
    box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.08);
    border-radius: 10px;
    margin: 11px;
    padding-bottom: 10px;
  }

  .line {
    width: 1px;
    height: 100%;
    background-color: #CCCCCC;
    min-height: 100px;
  }

  .tablemain {
    width: 537px;
    margin-left: 20px;
    justify-content: start;

    span {
      margin: 12px 10px 19px 0px;
    }
  }

  .table1 {
    min-height: 100px;
    // padding-bottom: 10px;
    margin-bottom: 10px;

    .tablename {
      height: 100%;
      width: 173px;

      p {
        width: 100%;
        text-align: center;
      }
    }

    width: 716px;
    // height: 260px;
    background: #FFFFFF;
    box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.08);
    border-radius: 10px;
    margin: 21px 0 0 7px;
    z-index: 100;
  }

  .table2 {
    min-height: 100px;
    justify-content: space-around;
    margin-bottom: 10px;
    padding-bottom: 0;

    .tablename {
      height: 100%;

      p {
        width: 100%;
        text-align: center;
      }
    }

    .tablemain {
      padding-left: 10px;
      border-left: 1px solid #CCCCCC;
    }

    width: 716px;
    // height: 260px;
    background: #FFFFFF;
    box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.08);
    border-radius: 10px;
    margin: 21px 0 0 16px;
  }

  .info4 {
    overflow: hidden;
    margin-bottom: 39px;
    padding-bottom: 5px;

    &>div {
      width: 133px;
      height: 103px;
      background: #FFFFFF;
      box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.08);
      border-radius: 10px;
      margin: 19px 0 0px 2px;
      margin-right: 21px;
    }

    .rank {
      color: $color;
      margin-top: 17px;
      margin-bottom: 18px;

      span {
        font-size: 22px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: $color;
      }
    }
  }

  .left {

    margin-right: 42px;
  }

  .right {}

  .biaoti {
    font-size: 18px;
    font-family: Microsoft YaHei;

    color: #333333;
    margin-bottom: 15px;
  }

  .neirong {
    font-weight: bold;
    font-size: 18px
  }

  .info3 {
    width: 100%;
    background: #FFFFFF;
    box-shadow: 0px 0px 18px 0px rgba(0, 0, 0, 0.08);
    border-radius: 10px;
    margin: 24px 0 46px 2px;
    flex-wrap: wrap;

    &>span {
      width: 22%;
      margin: 10px;

      span>div {
        text-align: left;
      }
    }
  }

  .info2 {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    line-height: 40px;
    text-indent: 36px;
    text-align: left;
    margin-bottom: 81px;
  }

  .url {
    margin-top: 10px;
    color: #999999;

    span {
      cursor: pointer;
    }

    span:hover {
      color: #004adf;
    }
  }

  .info1 {
    width: 100%;
    margin-bottom: 47px;
    justify-content: space-between;
    border: 1px solid #CCCCCC;
    border-radius: 20px;

    .url span {
      margin-right: 47px;
    }

    .name {
      font-weight: 400;
      margin-bottom: 12px;
      color: #333333;
      line-height: 30px;
      font-size: 26px;
    }

    .type {
      margin-top: 17px;
      margin-bottom: 21px;

      span {
        height: 22px;
        color: $color;
        border: 1px solid $color;
        border-radius: 11px;
        padding: 2px 5px;
        margin-right: 18px;
      }
    }

    text-align: left;
  }

  .logo {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    margin-right: 16px;
  }

  .hello {
    margin: 48px auto;
    width: 1280px;
  }

  .search_input {
    justify-content: space-between;
    position: relative;
  }

  .search_input input {
    width: 300px;
    outline: none;
    -webkit-appearance: none;
    background-color: #FFF;
    background-image: none;
    border-radius: 4px;
    border: 1px solid $color;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    height: 42px;
    line-height: 40px;
    outline: 0;
    padding: 0 15px;
    -webkit-transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
    transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
    //border: none;
    //border: 1px solid $color !important;
  }

  .search_icon {
    position: absolute;
    width: 20px;
    height: 20px;
    right: 20px;
    top: 10px;
  }

  .schoolscore {
    position: relative;

    .vip_mask {
      width: 100%;
      height: 95%;
      background-color: rgba(0, 0, 0, 0.08);
      position: absolute;
      top: 5%;
      left: 0;
      backdrop-filter: blur(15px)
    }

    .vip_mask img {
      margin-top: 30%;
      margin-bottom: 50px;
    }
  }
</style>
<style>
  .el-tabs--left.el-tabs--card .el-tabs__item.is-left:first-child {
    border: 1px solid #E4E7ED !important;
    /* border-top: none; */
  }
</style>



// WEBPACK FOOTER //
// src/view/school/schoolDetail.vue